<template>
    <van-popup v-model:show="show" position="center" :style="{
        minWidth: '90%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
    }" @click-overlay="close">
        <div class="popupContainer">
            <div class="popTitle">{{ $t('deposit.firstDepositTitle') }}</div>
            <div class="subText">{{ $t('deposit.getMoreBonus') }}</div>
            <van-row class="btnGroup">
                <van-col span="8" class="btnCol">
                    <div class="click_btn" @click="callDoNotshow">{{ $t('deposit.dontShowAgain') }}</div>
                </van-col>
                <van-col span="8" class="btnCol">
                    <div class="click_btn" @click="handleIgnoreToday">{{ $t('deposit.ignoreToday') }}</div>
                </van-col>
                <van-col span="8" class="btnCol">
                    <div class="click_btn" @click="depositEnter">{{ $t('deposit.enter') }}</div>
                </van-col>
            </van-row>

        </div>

    </van-popup>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import { checkDate } from '@/utils/commonFunction';
import { callFirstRechargePopupNotShow } from '@/api/deposit';
import { useUserStore } from '@/stores/user';
import { callDoNotshowFunc } from '@/view/deposit/supportScript';

const { t } = useI18n();
const userStore = useUserStore()
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const emits = defineEmits(['checkPopupFlow'])
const open = () => {
    const ignoreDate = localStorage.getItem('ignoreDate') || ''
    if (ignoreDate) {
        if (checkDate(ignoreDate) == 0) {
            show.value = false
        } else {
            show.value = true
        }
    } else {
        show.value = true
    }
}

const close = () => {
    // userStore.setFirstRechargePopupShowStatus(0)
    userStore.setRechargeBonusType(0)
    let takeFirstDepositStatus = userStore.takeFirstDeposit
    if(!takeFirstDepositStatus){
        userStore.setisFirstRechargeRewardEligible(false)
    }else{
        userStore.setisFirstRechargeRewardEligible(true)
    }
    
    show.value = false  
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const handleIgnoreToday = () => {
    const today = new Date();
    const todayDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    localStorage.setItem('ignoreDate', todayDate);
    show.value = false
    userStore.setisFirstRechargeRewardEligible(false)
    userStore.setRechargeBonusType(0)
}
const depositEnter = () => {
    userStore.setRechargeBonusType(2)
    show.value = false
}
const callDoNotshow = async () => {
    await callDoNotshowFunc(callFirstRechargePopupNotShow,loadingRef,showSuccess,showError,userStore,show)
    await userStore.getInfo()
    emits('checkPopupFlow')  
}
defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    background:  #101629;
    box-shadow: 0px 0px 10px rgba(77, 98, 241, 0.4);
    padding: 15px;
    border-radius: 20px;
    /* width: 90%; */
    overflow: hidden;
}

.popTitle {
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    padding: 10px;
}

.subText {
    color: #ffffffa6;
    font-size: 14px;
    font-style: italic;
    display: flex;
    justify-content: center;
    text-align: center;
    padding: 10px;
}

.btnGroup {
    padding: 10px;
}

.click_btn {
    color: #FFFF;
    font-size: 14px;
     background-image: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%);
    border-radius: 5px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    min-width: 80%;
    height: 100%;
}

.btnCol {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 5px;
}

@media (max-width: 360px) {
  .popupContainer {
    padding: 12px;
    border-radius: 14px;
  }

  .popTitle {
    font-size: 15px;
    padding: 8px;
  }

  .subText {
    font-size: 12px;
    padding: 6px;
  }

  .btnGroup {
    padding: 6px;
  }

  .click_btn {
    font-size: 10px;
    /* padding: 6px 8px;
    min-width: 100%; */
  }

  .btnCol {
    padding: 4px;
  }
}

@media (max-width: 460px) {
  .popupContainer {
    padding: 12px;
    border-radius: 14px;
  }

  .popTitle {
    font-size: 15px;
    padding: 8px;
  }

  .subText {
    font-size: 12px;
    padding: 6px;
  }

  .btnGroup {
    padding: 6px;
  }

  .click_btn {
    font-size: 11px;
    /* padding: 6px 8px;
    min-width: 100%; */
  }

  .btnCol {
    padding: 4px;
  }
}
</style>